import { render, staticRenderFns } from "./Zkp.vue?vue&type=template&id=d1466df2&scoped=true&"
var script = {}
import style0 from "./Zkp.vue?vue&type=style&index=0&id=d1466df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1466df2",
  null
  
)

export default component.exports